// Guardian addresses for "Email guardians": primary and secondary, unique, case-insensitive.
export function guardianEmails(rows) {
  const seen = new Map();
  rows.forEach(r => {
    [r.primaryGuardian?.email, r.secondaryGuardian?.email].forEach(email => {
      const value = String(email || '').trim();
      if (value && !seen.has(value.toLowerCase())) seen.set(value.toLowerCase(), value);
    });
  });
  return [...seen.values()];
}

// Mail apps and browsers cut mailto: links somewhere above ~2,000 characters.
export const MAILTO_LIMIT = 2000;

export function bccMailto(emails) {
  return `mailto:?bcc=${encodeURIComponent(emails.join(','))}`;
}
